import { StoreDTO } from '../../dto';

interface StoreProps {
  storeNumber: number;
  name: string;
  retailerNumber: number;
  retailerName: string;
  urlName: string;
}

export class Store {
  storeNumber: number;
  name: string;
  retailerNumber: number;
  retailerName: string;
  urlName: string;

  constructor({ storeNumber, name, retailerNumber, retailerName, urlName }: StoreProps) {
    this.storeNumber = storeNumber;
    this.name = name;
    this.retailerNumber = retailerNumber;
    this.retailerName = retailerName;
    this.urlName = urlName;
  }

  static getCircularLogoUrl = (urlName: string, baseLogoUrl: string): string => {
    return `${baseLogoUrl}/${urlName}_circle_64_clr.png`;
  };

  static fromDto = (dto: StoreDTO): Store =>
    new Store({
      storeNumber: dto.storeNumber,
      name: dto.name,
      retailerNumber: dto.retailerNumber,
      retailerName: dto.retailerName,
      urlName: dto.urlName,
    });
}
